import React from 'react';
import styles from 'HStack.module.scss';

interface Props {
	children: React.ReactElement | React.ReactElement[];
	style?: React.CSSProperties;
}

const HStack: React.FC<Props> = ({ children, style }) => {
	return (
		<div className={styles.wrapper} style={style}>
			{React.Children.map(children, (child, index) => {
				return (
					<div className={styles.item} key={index}>
						{child}
					</div>
				);
			})}
		</div>
	);
};

export default HStack;
